import React from 'react';

const ATTRIBUTE_LABELS = {
  action: 'Action', status: 'Statut', reason: 'Raison', location: 'Lieu', period: 'Période',
  trend: 'Tendance', amount_eur: 'Montant €', people_count: 'Personnes',
};

const Attributes = ({ value }) => {
  const entries = Object.entries(value || {}).filter(([key, v]) => key !== 'products' && v != null && v !== '');
  const products = (value?.products || []).filter(Boolean);
  if (!entries.length && !products.length) return <span className="text-gray-300 dark:text-gray-600">—</span>;
  return (
    <dl className="space-y-0.5 text-xs">
      {entries.map(([key, v]) => (
        <div key={key} className="flex gap-1.5">
          <dt className="flex-shrink-0 text-gray-400 dark:text-gray-500">{ATTRIBUTE_LABELS[key] || key}</dt>
          <dd className="text-gray-700 dark:text-gray-200">{String(v)}</dd>
        </div>
      ))}
      {products.map((p, i) => (
        <div key={i} className="flex gap-1.5">
          <dt className="flex-shrink-0 text-gray-400 dark:text-gray-500">Produit</dt>
          <dd className="text-gray-700 dark:text-gray-200">
            {[p.ref, p.label, p.brand, p.quantity != null && `× ${p.quantity}`, p.price != null && `${p.price} €`, p.mechanism, p.status].filter(Boolean).join(' · ')}
          </dd>
        </div>
      ))}
    </dl>
  );
};

export default Attributes;
